import CustomBreadCrumbs from '@/components/atom/CustomBreadCrumbs';
import PaginationComponent from '@/components/common/PaginationComponent';
import LinkTag from '@/components/common/link-tag';
import TemplateLayout from '@/components/layouts/TemplateLayout';
import { zIndex } from '@/constants/zIndex';
import DNSearchBar from '@/design-components/organisms/dnsearch-bar';
import { DiseaseEncyclopedia } from '@/entities/disease-encyclopedia';
import { createDiseaseEncyclopediaDetailUrl } from '@/entities/disease-encyclopedia/util';
import { Client, ClientType } from '@/types/app';
import { ROUTES } from '@/types/common';
import { DiseaseEncyclopediaTotalViewModel } from '@/views/disease-encyclopedia/total/hooks/useDiseaseEncyclopediaTotalViewModel';
import React from 'react';

interface Props {
  viewModel: DiseaseEncyclopediaTotalViewModel;
  client: Client;
}

const DiseaseEncyclopediaTotalView = (props: Props) => {
  return (
    <TemplateLayout.Wrapper>
      {props.client.clientType === ClientType.WEB && (
        <CustomBreadCrumbs.Wrapper>
          <CustomBreadCrumbs visible breadCrumbs={props.viewModel.breadCrumbs} />
        </CustomBreadCrumbs.Wrapper>
      )}

      <div className='typography-ui-22sb px-[24px] py-[16px] text-gray-900'>질환백과</div>

      <div
        className='px-[24px] py-[16px]'
        style={{
          zIndex: zIndex.AppHeader,
          top: props.client.clientType === ClientType.MOBILE_WEB ? '60px' : '0px',
        }}
      >
        <DNSearchBar
          value={props.viewModel.keyword}
          placeholder={'질환 이름 혹은 증상 검색'}
          shouldShowResetButton={!!props.viewModel.keyword}
          searchInputRef={props.viewModel.searchInputRef}
          onSubmit={props.viewModel.handleSubmit}
          onReset={props.viewModel.handleResetSearchKeyword}
          onChange={props.viewModel.handleChangeSearchKeyword}
        />
      </div>

      <div className='pt-[16px] pb-[80px]'>
        <div className='mb-[20px] flex items-center gap-[4px] px-[24px]'>
          <h2 className='typography-ui-20sb text-gray-700'>전체 질환</h2>
        </div>
        <>
          <div className='grid grid-cols-1 gap-[20px] px-[24px] sm:grid-cols-2 sm:gap-[28px]'>
            {props.viewModel.keywordSearchDiseaseEncyclopedia?.elements?.map((diseaseEncyclopedia, index, array) => (
              <React.Fragment key={diseaseEncyclopedia.getPublicId()}>
                <LinkTag
                  key={diseaseEncyclopedia.getPublicId()}
                  href={createDiseaseEncyclopediaDetailUrl(diseaseEncyclopedia)}
                  onClickNavigateToScreen={props.viewModel.onClickDiseaseEncyclopedia(diseaseEncyclopedia)}
                >
                  <DiseaseEncyclopedia
                    key={diseaseEncyclopedia.getPublicId()}
                    title={diseaseEncyclopedia.getTitle()}
                    summary={diseaseEncyclopedia.getContent()}
                    image={diseaseEncyclopedia.getTitleImageUrl() ?? undefined}
                  />
                </LinkTag>
                {props.client.isMobile && index !== array.length - 1 && <div className='h-[1px] w-full bg-gray-40' />}
              </React.Fragment>
            ))}
          </div>
          <PaginationComponent
            baseUrl={ROUTES.DISEASE_ENCYCLOPEDIA.TOTAL.path}
            queries={props.viewModel.queries}
            currentPage={props.viewModel.currentPage}
            perPage={5}
            totalPage={props.viewModel.totalPage}
          />
        </>
      </div>
    </TemplateLayout.Wrapper>
  );
};

export default DiseaseEncyclopediaTotalView;
